import { createFileRoute } from '@tanstack/react-router';

import { BrandingPage } from '@/areas/settings/manufacturing/Settings/BrandingPage/BrandingPage';
import { canViewGeneralSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/branding')({
    staticData: {
        access: { permissions: canViewGeneralSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <BrandingPage />;
}
